/**
 * Onboarding helpers (SP5, cue-forge-9ww.2): a small bundled sample so first-time
 * users can explore every mode without their own file, plus a one-time first-run
 * flag. All local — nothing is fetched.
 */

/** A short, styled sample subtitle (italics + a two-line cue) to explore with. */
export const SAMPLE_SRT = `1
00:00:01,000 --> 00:00:03,500
Welcome to CueForge.

2
00:00:04,000 --> 00:00:07,000
<i>Everything runs in your browser —</i>
your files never leave this device.

3
00:00:08,000 --> 00:00:11,000
Convert, QC, repair, and re-sync subtitles.
`;

/** A File built from {@link SAMPLE_SRT}, loadable through the normal session path. */
export function sampleFile(): File {
  return new File([SAMPLE_SRT], 'sample.srt', { type: 'text/plain' });
}

const ONBOARDED_KEY = 'cueforge.onboarded';

/** True until the user has loaded their first document (across sessions). */
export function isFirstRun(): boolean {
  try {
    return globalThis.localStorage?.getItem(ONBOARDED_KEY) !== '1';
  } catch {
    return false;
  }
}

/** Record that the user has loaded something, so first-run guidance shows once. */
export function markOnboarded(): void {
  try {
    globalThis.localStorage?.setItem(ONBOARDED_KEY, '1');
  } catch {
    /* storage unavailable */
  }
}
